import React from 'react';
import '../../style/FloatingCard.css';
import {
	FloatingCardInner, 
	FloatingCardStyled
} from './StyleComponents/StyleFloatingCard';


const FloatingCard = (props) => {
	return (
		<FloatingCardStyled>
			<FloatingCardInner>
				{props.children}
			</FloatingCardInner>
		</FloatingCardStyled>
	);

};

export default FloatingCard;